module.exports = __webpack_public_path__ + "img/linktable.ffbfb97d.svg";